export default function Logo({ className }) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="1131.858px"
      height="459.942px"
      viewBox="0 0 1131.858 459.942"
      className={className}
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1106.987,13.12c-10.791,8.852-22.14,17.112-32.278,26.658
  c-49.245,46.368-78.172,103.314-86.89,170.379c-1.606,12.359-2.304,24.87-2.696,37.334c-0.141,4.456-2.062,5.468-5.544,6.523
  c-60.834,18.458-120.898,39.104-179.404,64.064c-51.989,22.181-102.588,47.022-148.687,80.128
  c-21.446,15.401-41.511,32.373-57.656,53.527c-0.271,0.355-0.739,0.561-1.786,1.329c0-1.948,0-3.342,0-4.734
  c0-21.825,0.062-43.65-0.07-65.475c-0.019-3.065,0.823-4.574,3.706-5.982c26.347-12.88,40.863-34.16,40.888-63.422
  c0.024-29.258-14.43-50.57-40.758-63.516c-2.763-1.358-3.915-2.724-3.851-5.909c0.221-10.992,0.287-21.997-0.021-32.983
  c-0.112-3.968,1.049-5.748,4.833-7.161c60.605-22.637,121.151-45.432,181.7-68.218c107.569-40.483,215.131-80.985,322.7-121.467
  c1.706-0.643,3.47-1.138,5.206-1.702C1106.572,12.71,1106.775,12.919,1106.987,13.12z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.457,12.482c25.558,9.528,51.14,18.991,76.669,28.596
  c144.153,54.232,288.285,108.52,432.475,162.653c4.121,1.546,5.489,3.403,5.335,7.804c-0.378,10.816-0.2,21.655-0.07,32.484
  c0.033,2.771-0.565,4.36-3.36,5.713c-26.79,12.96-41.422,34.496-41.223,64.196c0.197,29.271,14.925,50.338,41.221,63.333
  c1.49,0.736,3.155,2.996,3.169,4.562c0.202,23.474,0.14,46.95,0.14,70.955c-0.817-0.465-1.446-0.625-1.759-1.03
  c-21.198-27.429-48.294-48.111-77.034-66.777c-49.209-31.963-102.257-56.328-156.557-78.13
  c-49.726-19.967-100.429-37.143-151.707-52.624c-4.776-1.441-5.824-3.548-5.958-8.213c-2.763-96.198-41.67-173.736-119.714-230.953
  c-0.784-0.574-1.471-1.28-2.204-1.924C27.081,12.919,27.273,12.705,27.457,12.482z"
        />
      </g>
    </svg>
  );
}
